import { useEffect } from "react";
import { useSelector } from "react-redux";

/**
 * Custom hook to handle user-specific state persistence
 * This hook monitors user changes and logs state loading events
 * The actual persistence is handled automatically by store.js
 */
export const useUserPersistence = () => {
  const userInfo = useSelector((state) => state.user.userInfo);
  const currentUserId = userInfo?.id || userInfo?._id || "guest";

  useEffect(() => {
    // Log when user changes (for debugging)
    console.log(`Current user: ${currentUserId}`);
  }, [currentUserId]);
};
